import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth, isAdmin } from '../services/auth';
import { errorMessage } from '../services/api';
import { APP_NAME, LOGO } from '../brand';

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const user = await login(username.trim(), password);
      navigate(isAdmin(user) ? '/admin' : '/hotesse', { replace: true });
    } catch (err) {
      setError(err.response?.status === 401 ? 'Identifiant ou mot de passe incorrect.' : errorMessage(err));
    } finally {
      setLoading(false);
    }
  };

  const label = { color: '#0d47a1', fontWeight: 'bold', textTransform: 'uppercase', fontSize: '12px', letterSpacing: '1px' };
  const input = { borderRadius: '10px', padding: '12px', border: '2px solid #1565c0', fontSize: '16px', background: '#f5f9ff' };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f4f6f9', padding: '20px', position: 'relative', overflow: 'hidden' }}>
      <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, height: '8px', background: 'linear-gradient(90deg, #0d47a1 0%, #1565c0 50%, #1976d2 100%)' }}></div>
      <div style={{ maxWidth: '450px', width: '100%', background: '#ffffff', borderRadius: '20px', padding: '40px', boxShadow: '0 25px 70px rgba(0, 0, 0, 0.3)', border: '3px solid #1565c0', position: 'relative', zIndex: 1 }}>
        <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: '6px', background: 'linear-gradient(90deg, #0d47a1 0%, #1976d2 50%, #42a5f5 100%)', borderRadius: '17px 17px 0 0' }}></div>
        <div style={{ textAlign: 'center', marginBottom: '30px', marginTop: '15px' }}>
          <div style={{ width: '100px', height: '100px', borderRadius: '50%', background: '#ffffff', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 15px', boxShadow: '0 6px 20px rgba(21, 101, 192, 0.4)', overflow: 'hidden', padding: '4px' }}>
            <img src={LOGO} alt="Supermont" style={{ width: '100%', height: '100%', objectFit: 'contain', borderRadius: '50%' }} />
          </div>
          <h2 style={{ color: '#0d47a1', fontWeight: 'bold', margin: '10px 0 4px', fontSize: '26px', letterSpacing: '1px' }}>{APP_NAME}</h2>
          <p style={{ color: '#1976d2', fontWeight: 600, margin: 0, fontSize: '14px', letterSpacing: '2px', textTransform: 'uppercase' }}>Supermont</p>
        </div>

        {error && (
          <div className="alert alert-danger mb-3" role="alert" style={{ background: '#e3f2fd', border: '2px solid #1565c0', color: '#0d47a1', borderRadius: '10px' }}>
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className="form-label" htmlFor="u" style={label}>Nom d'utilisateur</label>
            <input id="u" type="text" className="form-control" value={username} onChange={(e) => setUsername(e.target.value)}
              required autoFocus autoCapitalize="none" autoComplete="username" style={input} />
          </div>
          <div className="mb-4">
            <label className="form-label" htmlFor="p" style={label}>Mot de passe</label>
            <input id="p" type="password" className="form-control" value={password} onChange={(e) => setPassword(e.target.value)}
              required autoComplete="current-password" style={input} />
          </div>
          <button type="submit" className="btn btn-primary w-100" disabled={loading}
            style={{ background: 'linear-gradient(180deg, #1976d2 0%, #1565c0 50%, #0d47a1 100%)', border: 'none', borderRadius: '15px', padding: '15px', fontSize: '18px', fontWeight: 'bold', textTransform: 'uppercase', letterSpacing: '2px', color: '#ffffff', boxShadow: '0 8px 25px rgba(21, 101, 192, 0.4)' }}>
            {loading ? (<><span className="spinner-border spinner-border-sm me-2"></span>Connexion...</>) : 'Se connecter'}
          </button>
        </form>

        <div style={{ textAlign: 'center', marginTop: '25px' }}>
          <small style={{ color: '#1565c0', fontWeight: 'bold', fontSize: '12px' }}>&copy; 2026 SUPERMONT &mdash; {APP_NAME}</small>
        </div>
      </div>
    </div>
  );
}
